import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface AccidentRemoveConfirmDialogProps {
  open: boolean;
  onClose?: () => void;
  onAccept?: () => void;
  onDeny?: () => void;
}

export const AccidentRemoveConfirmDialog = ({ onDeny, onClose, onAccept, open }: AccidentRemoveConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">Odstranění nehody</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Opravdu chcete smazat tento záznam? Tento krok nelze vzít zpět.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          py: 4,
          justifyContent: 'center',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          gap: 2
        }}
      >
        <Button onClick={onDeny}>Zavřít</Button>
        <Button autoFocus variant="contained" color="error" onClick={onAccept}>
          Smazat záznam
        </Button>
      </DialogActions>
    </Dialog>
  );
};
